import { render, staticRenderFns } from "./SecKillRefundPane.vue?vue&type=template&id=e331542e&scoped=true"
import script from "./SecKillRefundPane.vue?vue&type=script&lang=js"
export * from "./SecKillRefundPane.vue?vue&type=script&lang=js"
import style0 from "./SecKillRefundPane.vue?vue&type=style&index=0&id=e331542e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e331542e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e331542e')) {
      api.createRecord('e331542e', component.options)
    } else {
      api.reload('e331542e', component.options)
    }
    module.hot.accept("./SecKillRefundPane.vue?vue&type=template&id=e331542e&scoped=true", function () {
      api.rerender('e331542e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/secKill/SecKillRefundPane.vue"
export default component.exports